import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

export const NewOutstandingBalance = ({
    drawdownAmount,
    outstandingBalance
}: {
    drawdownAmount: number;
    outstandingBalance: number;
}) => {
    // Drawdown amount will be 0 for repayment reduction applications
    const newOutstandingBalance = outstandingBalance + (drawdownAmount || 0);

    return (
        <div className="flex items-center justify-between">
            <Text>
                <FormattedMessage
                    id="_.topup_choice.new_loan_summary_outstanding_balance"
                    defaultMessage="Outstanding balance"
                />
            </Text>
            <Text className="font-med" data-testid="new-outstanding-balance">
                <FormattedCurrency value={newOutstandingBalance} />
            </Text>
        </div>
    );
};
